export default "__VITE_ASSET__DMhPaL_E__"